import store from 'sky-engine/store'

import articleManage from './modules/articleManage'
import permission from './modules/permission'
import user from './modules/user'
const modules = {
  permission,
  user,
  articleManage
}

for (const key in modules) {
  if (Object.prototype.hasOwnProperty.call(modules, key)) {
    const rawState = modules[key].state
    if (typeof rawState === 'function') {
      modules[key].state = function() {
        return rawState
      }
    }
    store.registerModule(key, modules[key])
  }
}

export default store
